<!--万达电影app-我的-推荐位-万达谷仓-->
<template>
  <div class="home">
    <img src="./home.png" alt="">
    <div class="clickBlock area1" @click="area1Fun"></div>
    <div class="clickBlock area2" @click="area2Fun"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    // HelloWorld,
  },
  methods:{
    area1Fun(){
      this.$router.push('Granary')
    },
    area2Fun(){
      this.$router.push('Index')
    }
  }
};
</script>
<style lang="less" scoped>
  .home {
    width: 100vw;
    height: 100vh;
    position: relative;
    >img {
      position: relative;
      width: 100%;
      height: 100%;
      display: block;
      margin: 0;
      padding: 0;
    }
    .area1 {
      width: 15vw;
      height: 15vw;
      top: 71vh;
      left: 10vw;
    }
    .area2 {
      width: 15vw;
      height: 15vw;
      top: 90vh;
      left: 5vw;
    }
  }
</style>
